module.exports = __webpack_public_path__ + "static/media/map-marker-plus.1a4a02b5.svg";